import { combineReducers } from 'redux';

import native from './native';
import search from './search';
import layout from './layout';
import download from './download';
import WelcomApp from './welcomePopUp';
import recommend from './recommend';
import topn from './topn';
import category from './category';
import detail from './detail';
import network from './network';
import log from './log';

// 5.2新增
import acategory from './acategory';
import adetail from './adetail';
import arecommend from './arecommend';
import asimstatus from './asimstatus';

// 5.3新增
import comment from './comment';
import user from './user';

// 5.5新增
import special from './special';
// 6.0新增 壁纸
import wallpaper from './wallpaper';
// 6.1 新增 我的软件
import uninstall from './uninstall';
// 6.5 用户引导
import welcome from './welcome';
// 游戏页
import game from './game';
// 用户反馈
import userFeedback from './userFeedback';
// 卡片的请求
import card from './card';

// v7.0教育频道
import education from './education';

export default combineReducers({
  native,
  search,
  layout,
  download,
  recommend,
  topn,
  category,
  WelcomApp,
  detail,
  network,
  log,
  asimstatus,
  arecommend,
  acategory,
  adetail,
  comment,
  user,
  special,
  wallpaper,
  uninstall,
  welcome,
  game,
  userFeedback,
  card,
  education,
});
